export default {
  dateInput: {
    placeholder: "dd/mm/aaaa",
    openCalendar: "Abrir calendário",
    invalid: "Data inválida: use dd/mm/aaaa",
  },
  myProfile: "My Profile",
  billing: "Faturação",
  success: "Success",
  error: "Error",
  ok: "OK",
  validationSaveFailedTitle: "Erro de validação",
  validationSaveFailedIntro:
    "Não foi possível guardar o registo pelos seguintes motivos:",
  validationSaveAnyway: "Guardar mesmo assim",
  validationUnderstood: "OK",
  expenseFileMissingTitle: "Sem Related File anexado",
  expenseFileMissingText:
    "Está a guardar sem anexar o Related File. Quer continuar mesmo assim?",
  expenseFileMissingCancel: "Cancelar",
  validationPendingAmountToApply: "Ainda tem um montante pendente a aplicar",
  contactOutsideOperationTitle: "Contacto fora da operação",
  shippingIncoherenceTitle: "Incoerências neste embarque",
  contactOutsideOperationText:
    "{contact} não participa de {operations}: não é o cliente, o fornecedor nem o contacto de nenhuma despesa. Se um terceiro paga ou recebe, está bem; caso contrário, reveja o contacto.",
  contactOutsideOperationCancel: "Rever",
  contactOutsideOperationBanner:
    "Este registo está aplicado a {operations}, mas {contact} não participa dessa operação (não é o cliente, o fornecedor nem o contacto de nenhuma despesa). Verifique se o contacto está correto.",
  collectContactNotClientTitle: "O recebimento não é do cliente",
  collectContactNotClientText:
    "{contact} não é o cliente de {operations}. Se um terceiro paga pelo cliente, está bem; caso contrário, reveja o contacto.",
  collectContactNotClientBanner:
    "Este recebimento está aplicado a {operations}, mas {contact} não é o cliente dessa operação. Verifique se o contacto está correto.",
  validationForceSaveSessionTitle: "Sessão expirada",
  validationForceSaveSessionText:
    "Não foi possível guardar mesmo assim porque a sessão expirou. Atualize a página ou inicie sessão novamente e tente de novo.",
  validationForceSaveGenericText:
    "Não foi possível concluir o guardado forçado. Verifique a ligação e tente de novo.",
  routerNavLoading: "A carregar…",
  testEnvironmentBanner: "Versão de teste — ambiente local",
  testEnvironmentBannerHosted:
    "Versão de teste — está a ver uma cópia de teste (não é produção)",
  "systemFeaturesPermissionDeniedTitle": "Sem permissão",
  "systemFeaturesPermissionDeniedText":
    "Não tem permissão para ativar ou desativar funcionalidades do sistema. Peça a um administrador a permissão «Access system features» (systemfeatures.access) no seu perfil.",
  registerSuccessLogin: "Conta criada. Já pode iniciar sessão.",
  registerConfirmEmailSent:
    "Enviámos-lhe um link para o seu e-mail ({email}) para confirmar a sua conta. Se não o recebeu, verifique o spam. Clique no link para confirmar a conta.",
  forgotPassword: "Esqueceu-se da palavra-passe?",
  passwordResetEmail: "Introduza o seu e-mail e enviaremos um link para definir uma nova palavra-passe.",
  passwordResetContinue: "Continuar",
  emailSent: "Redefinir palavra-passe",
  correctEmail: "Vamos enviar o link de redefinição para {email}. Está correto?",
  sendEmail: "Enviar e-mail",
  pleaseinsertemail: "Introduza o e-mail com que se registou para ser redirecionado para a sua aplicação.",
  goToMyApp: "Ir para a minha aplicação",
  seeDemo: "Ver demonstração",
  incorrectUserOrPassword: "Utilizador ou palavra-passe incorretos",
  accountconfirm: "A sua conta foi confirmada, já pode iniciar sessão.",
  getStarted: "Começar",
  "Search fields...": "Pesquisar campos...",
  'No fields found for "{query}"': 'Nenhum campo encontrado para "{query}"',
  "Type to search records...": "Digite para pesquisar registros...",
  "Type to search a record...": "Digite para pesquisar um registro...",

  // Register.vue (chaves raiz para $t)
  name: "Nome",
  email: "E-mail",
  password: "Palavra-passe",
  businessName: "Nome do negócio",
  login: "Iniciar sessão",
  confirmEmailText: "Verifique o seu e-mail para confirmar a conta",
  nameAlreadyTaken: "Este nome já está em uso",
  errorCheckingRestaurantName:
    "Não foi possível verificar a disponibilidade do nome",
  nameRequired: "O nome é obrigatório",
  countryRequired: "O país é obrigatório",
  restaurantNameRequired: "O nome do negócio é obrigatório",
  emailRequired: "O e-mail é obrigatório",
  emailInvalid: "O e-mail não é válido",
  passwordRequired: "A palavra-passe é obrigatória",
  userExists: "Já existe uma conta com este e-mail",
  registerCompanyLinkPlaceholder: "Link do seu negócio (opcional)",
  registerHelpBusinessUrl:
    "Usamos o nome do seu negócio no URL de que os seus clientes precisam para aceder à aplicação.",
  registerHelpDedicatedDbConfirm:
    "Depois de confirmar o e-mail, é criada uma base de dados dedicada ao seu negócio (o mesmo utilizador nesta instância e na nova).",
  registerHelpDedicatedDbImmediate:
    "É criada de imediato uma base de dados dedicada ao seu negócio (o mesmo utilizador nesta instância e na nova).",
  registerHelpCompanyLink:
    "Indique o link do Instagram, Facebook ou site do negócio para o podermos incluir em campanhas de marketing.",
  registerHelpEmailConfirmBusiness:
    "Enviaremos um e-mail com um link para confirmar a conta; a base de dados do negócio é criada ao confirmar.",
  registerHelpEmailConfirmAny:
    "Enviaremos um e-mail com um link para confirmar a conta; não poderá iniciar sessão até confirmar.",
  registerConfirmSpamP1:
    "Se não encontrar o e-mail, verifique o spam. Se não recebeu a mensagem com o código, contacte-nos para ativar manualmente a conta. Envie e-mail para contact@gotake.it ou fale connosco no WhatsApp de suporte técnico, toque aqui:",
  registerConfirmWhatsapp: "WhatsApp",

  nothingtosee: "Nothing to see here",
  logout: "Logout",

  "Add new": "Adicionar novo",
  All: "Todos",

  // Tutorial translations
  tutorial: {
    // Welcome step
    welcome: {
      title: "Welcome to ExportAI Tutorial",
      description:
        "I will guide you through all the functionalities of the dynamic listing screen. You will learn to use filters, columns, searches and more.",
      details: [
        "This tutorial will show you step by step how each function works",
        "You can navigate with buttons or click on indicators",
        "At the end you will be able to use all tools like an expert",
      ],

      tip: "Take your time to understand each functionality. Don't worry if you don't remember everything, you can always review this tutorial.",
    },

    // Search step
    search: {
      title: "Keyword Search",
      description:
        "The search field allows you to quickly find records by typing any text that contains the information you are looking for.",
      details: [
        "Type any word or phrase to search",
        "Search is performed in all visible fields",
        "Results are filtered in real time",
        "You can clear the search with the X button",
      ],

      tip: 'Use specific words to get more precise results. For example, if you search for "John", all records containing that name will appear.',
    },

    // Column preferences step
    columnPreferences: {
      title: "Column Preferences",
      description:
        "The columns button allows you to completely customize which fields you want to see in your table and how to organize them.",
      details: [
        "Click on the button with columns icon to open the selector",
        "Check/uncheck fields to show or hide them",
        "Drag and drop to reorder columns",
        "Changes are automatically saved in your preferences",
        "You can group related fields for better organization",
      ],

      tip: "Organize the most important columns first to have a more efficient view of your data. Preferences are saved per user and model.",
    },

    // Filter preferences step
    filterPreferences: {
      title: "Filter Preferences",
      description:
        "The filters button allows you to configure which fields will be available for filtering and customize your filtering experience.",
      details: [
        "Click on the button with filter icon to open the selector",
        "Select which fields you want to be available for filtering",
        'You can check/uncheck individual fields or use "Select all"',
        "Selected fields will appear as filter buttons",
        "Preferences are automatically saved per user and model",
      ],

      tip: "Select only the fields you really need to filter to keep the interface clean and focused on what's important.",
    },

    // Filter usage step
    filterUsage: {
      title: "Using Configured Filters",
      description:
        "Once your preferences are configured, filters appear as buttons that you can use to refine your results.",
      details: [
        "Blue filters are applied and actively filter your data",
        "Gray filters are available to use when needed",
        "Click on any filter to configure its specific criteria",
        'You can expand to see more options with the "+ filters" button',
        "Combine multiple filters for more precise results",
      ],

      tip: "Keep only the filters you really need to avoid complicating your data view. Filters can be cleared individually or all at once.",
    },

    // Column sorting step
    columnSorting: {
      title: "Column Sorting",
      description:
        "Click on column headers to sort data ascending or descending.",
      details: [
        "Click on the header to sort ascending",
        "Click again to sort descending",
        "Sortable columns show an arrow icon",
        "Current order is maintained until you change the view",
      ],

      tip: "Combine sorting with filters to quickly find the most relevant records.",
    },

    // Individual column management step
    individualColumns: {
      title: "Individual Column Management",
      description:
        "Each column has individual options such as hide, reorder and customize.",
      details: [
        "Use the X button on each column to hide it",
        "Drag and drop headers to reorder",
        "Hidden columns can be restored from the selector",
        "Changes are applied immediately",
      ],

      tip: "Hide columns you don't use frequently to have a cleaner and more focused view.",
    },

    // Preferences system step
    preferencesSystem: {
      title: "Preferences System",
      description:
        "All your column and filter configurations are automatically saved and loaded every time you access the model.",
      details: [
        "Column preferences are saved per user and model",
        "Filter preferences are automatically saved",
        "When changing models, specific preferences are loaded",
        "You can reset preferences from the column selector",
        "Changes are synchronized in real time",
      ],

      tip: "Your preferences are maintained between sessions, so you won't have to configure everything again each time you access.",
    },

    // Report views step
    reportViews: {
      title: "Report Views",
      description:
        "Access different types of reports and custom views to analyze your data.",
      details: [
        "Each report button opens a different view",
        "Reports can show grouped or summarized data",
        "You can export results in different formats",
        "Views are saved and always available",
      ],

      tip: "Use different report views to analyze your data from multiple perspectives.",
    },

    // Bulk actions step
    bulkActions: {
      title: "Bulk Actions",
      description: "Perform operations on multiple selected records at once.",
      details: [
        'Select individual records or use "Select all"',
        "Perform bulk editing of common fields",
        "Delete multiple records at once",
        "Bulk actions save time on repetitive operations",
      ],

      tip: "Bulk actions are perfect for updating states, categories or any field that is common to multiple records.",
    },

    // Completion step
    completion: {
      title: "Tutorial Completed!",
      description:
        "Congratulations! Now you know all the main functionalities of the dynamic listing screen.",
      details: [
        "You can configure column and filter preferences",
        "Search and filter data efficiently",
        "Customize columns according to your needs",
        "Sort and organize information",
        "Access specialized reports and views",
        "Perform bulk actions when necessary",
      ],

      tip: "Practice with these functions to get familiar. Remember that you can always review this tutorial from the help menu.",
    },

    // Navigation buttons
    navigation: {
      previous: "Previous",
      next: "Next",
      complete: "Complete",
      exit: "Exit",
    },

    // Progress
    progress: "of",

    // Tip label
    tipLabel: "Tip:",
  },

  // TutorialButton translations
  tutorialButton: {},

  // Duntower field translations
  AccountNumber: "Account Number",
  "Additional costs": "Additional Costs",
  Address: "Address",
  Amount: "Amount",
  Applied: "Applied",
  "Applied to": "Applied to",
  "Auto load packing list": "Auto Load Packing List",
  "Autoload expenses": "Autoload Expenses",
  "Autoload invoice supplier": "Autoload Invoice Supplier",
  paymentOrderRequiresExpense:
    "Para gerar um pedido de pagamento deve primeiro criar o invoice supplier / proforma supplier em Expenses. Pode utilizar o botão autoload expense.",
  "BL Number": "BL Number",
  Balance: "Balance",
  "Bank account": "Bank Account",
  "Bank account (from)": "Bank account (from)",
  "Bank account (to)": "Bank account (to)",
  "Bank account (from) and Bank account (to) cannot be the same":
    "Bank account (from) and Bank account (to) cannot be the same",
  "Bank name": "Bank Name",
  "Billing Address": "Billing Address",
  "Billing address": "Billing Address",
  "Booking Number": "Booking Number",
  "Buyer refererence": "Buyer Reference",
  Cartons: "Cartons",
  Category: "Category",
  Flags: "Bandeiras",
  City: "City",
  Client: "Client",
  "Collect from": "Collect From",
  Collection: "Collection",
  "Collection Number": "Collection Number",
  "Collection date": "Collection Date",
  Collections: "Collections",
  Collects: "Collects",
  Comment: "Comment",
  Comments: "Comments",
  Contact: "Contact",
  Container: "Container",
  "Containers Involved": "Containers Involved",
  Country: "Country",
  "Country of final destination": "Country of Final Destination",
  "Country of origin": "Country of Origin",
  CountryOfOrigin: "Country of Origin",
  "Credit note": "Credit Note",
  "Credit notes amount": "Credit Notes Amount",
  Currency: "Currency",
  "Currency IN": "Currency IN",
  "Currency IS": "Currency IS",
  "Currency PS": "Currency PS",
  "Customer's commercial": "Customer's Commercial",
  "Cut off documents": "Cut Off Documents",
  "Cut off physical": "Cut Off Physical",
  "DHL date": "DHL Date",
  "DHL number": "DHL Number",
  Date: "Date",
  "Date Released": "Date Released",
  "Debit note": "Debit Note",
  "Debit notes amount": "Debit Notes Amount",
  Description: "Description",
  Documentation: "Documentation",
  "Done payments amount": "Done Payments Amount",
  Drafts: "Drafts",
  Emails: "Emails",
  "Estimated time of arrival (ETA)": "Estimated Time of Arrival (ETA)",
  "Estimated time of departure (ETD)": "Estimated Time of Departure (ETD)",
  Expense: "Expense",
  Expenses: "Expenses",
  "Expiration of import permit": "Expiration of Import Permit",
  "FR Comments": "FR Comments",
  File: "File",
  Forwarder: "Forwarder",
  "Forwarding agent": "Forwarding Agent",
  "Gate Out": "Gate Out",
  "Gross weight": "Gross Weight",
  Holder: "Holder",
  "IN Comments": "IN Comments",
  "IP applicable": "IP Applicable",
  Iban: "IBAN",
  Imagen: "Image",
  submittedby: "Submetido por {name} em {date}",
  updatedby: "Atualizado por {name} em {date}",
  "Import permit file": "Import Permit File",
  "Import permit number": "Import Permit Number",
  "In stock": "In Stock",
  Incoterm: "Incoterm",
  "Incoterm IS": "Incoterm IS",
  "Incoterm PS": "Incoterm PS",
  "Instr Comments": "Instructions Comments",
  "Instr Consignee": "Instructions Consignee",
  "Instr Consignee in certificate": "Instructions Consignee in Certificate",
  "Instr Invoice to": "Instructions Invoice to",
  "Instr Labelling": "Instructions Labelling",
  "Instr Notify": "Instructions Notify",
  "Instr Product": "Instructions Product",
  "Instr Shipper": "Instructions Shipper",
  "Intermediate port": "Intermediate Port",
  Invoice: "Invoice",
  "Invoice Date": "Invoice Date",
  "Invoice Number": "Invoice Number",
  "Invoice products": "Invoice Products",
  Language: "Language",
  "Letter of credit": "Letter of Credit",
  "Loading date": "Loading Date",
  Logo: "Logo",
  "Means of Convey": "Means of Conveyance",
  "Means of convey": "Means of Conveyance",
  Name: "Name",
  "Name of Vessel": "Name of Vessel",
  "Net weight": "Net Weight",
  Nombre: "Name",
  Notify: "Notify",
  Observations: "Observations",
  "Offer validity": "Offer Validity",
  "Original documents": "Original Documents",
  "PF Number": "PF Number",
  "PL Comments": "PL Comments",
  "Packing List": "Packing List",
  Paid: "Paid",
  "Payment conditions": "Payment Conditions",
  "Payment date": "Payment Date",
  "Payment supplier": "Payment Supplier",
  "Payment to": "Payment to",
  Payments: "Payments",
  "Pending payments amount": "Pending Payments Amount",
  Phone: "Phone",
  "Port Of Delivery": "Port of Delivery",
  "Port Of Origin": "Port of Origin",
  "Port of delivery": "Port of Delivery",
  "Port of incoterm": "Port of Incoterm",
  "Port of incoterm IS": "Port of Incoterm IS",
  "Port of incoterm PS": "Port of Incoterm PS",
  "Port of origin": "Port of Origin",
  "Postal code": "Postal Code",
  Price: "Price",
  Product: "Product",
  "Product and price": "Product and Price",
  Products: "Products",
  Proform: "Proforma",
  "Proform file": "Proforma File",
  "Proform number": "Proforma Number",
  "Proform number Date": "Proforma Number Date",
  "Qty containers": "Quantity Containers",
  "Qty of Cont": "Quantity of Containers",
  "Quantity of Containers": "Quantity of Containers",
  "Raw Weight": "Raw Weight",
  "Reference number": "Reference Number",
  ReferenceNumber: "Reference Number",
  "Related file": "Related File",
  "Release Method": "Release Method",
  "Release method": "Release Method",
  Remaining: "Remaining",
  "Request Date of Payment": "Request Date of Payment",
  "Seal Number": "Seal Number",
  "Shipper's commercial": "Shipper's Commercial",
  Shipping: "Shipping",
  "Shipping Line": "Shipping Line",
  ShippingLine: "Shipping Line",
  Signature: "Signature",
  "Sizing ref": "Sizing Reference",
  Status: "Status",
  Supplier: "Supplier",
  "Supplier Invoice number": "Supplier Invoice Number",
  "Supplier invoice date": "Supplier Invoice Date",
  "Supplier products": "Supplier Products",
  Swift: "SWIFT",
  Title: "Title",
  "To apply": "To Apply",
  Total: "Total",
  "Total (USD)": "Total (USD)",
  "Total Additional Cost": "Total Additional Cost",
  "Total Net Weight": "Total Net Weight",
  "Total Price": "Total Price",
  "Total Price Cont.": "Total Price Cont.",
  "Total Products and price": "Total Products and Price",
  "Total Qty Cont.": "Total Quantity Cont.",
  "Total Qty.": "Total Quantity",
  "Total Qty. Cont.": "Total Quantity Cont.",
  "Total Quantity": "Total Quantity",
  "Total Raw Weight": "Total Raw Weight",
  "Total add cost": "Total Additional Cost",
  "Total amount invoiced": "Total Amount Invoiced",
  "Total billed": "Total Billed",
  "Total containers": "Total Containers",
  "Total credit note": "Total Credit Note",
  "Total debit note": "Total Debit Note",
  "Total expenses": "Total Expenses",
  "Total invoice supplier": "Total Invoice Supplier",
  "Total net weight": "Total Net Weight",
  "Total product price": "Total Product Price",
  "Total proform": "Total Proforma",
  "Total qty": "Total Quantity",
  "Total quantity": "Total Quantity",
  TransitTime: "Transit Time",
  Type: "Type",
  "Type of Cont": "Type of Container",
  "Type of cont": "Type of Container",
  "Type of container": "Type of Container",
  "Type of document": "Type of Document",
  TypeOfContainer: "Type of Container",
  "Unit price": "Unit Price",
  "Unit qty": "Unit Quantity",
  "Validation date": "Validation Date",
  Website: "Website",

  shipping: "Shipping",

  "unit price": "Unit Price",
  "unit qty": "Unit Quantity",
  "Credit/Debit notes": "Credit/Debit Notes",
  Documents: "Documents",
  Expenses: "Expenses",
  Finance: "Finance",
  "Credit Notes": "Credit Notes",
  "Debit Notes": "Debit Notes",
  "Credit Notes Analysis": "Credit Notes Analysis",
  "Debit Notes Analysis": "Debit Notes Analysis",
  "credit notes": "credit notes",
  "debit notes": "debit notes",
  "No credit notes to display": "No credit notes to display",
  "No debit notes to display": "No debit notes to display",
  "Income - Expenses - Credit Notes + Debit Notes":
    "Income - Expenses - Credit Notes + Debit Notes",
  "Original Amount": "Original Amount",
  "Expected Amount": "Expected Amount",
  "Credit Notes": "Credit Notes",
  "Debit Notes": "Debit Notes",
  Adjusted: "Adjusted",
  Freight: "Freight",
  General: "General",
  "Import Permit": "Import Permit",
  "Invoice (IN)": "Invoice (IN)",
  "Invoice Supplier (IS)": "Invoice Supplier (IS)",
  Location: "Location",
  "Packing List (PL)": "Packing List (PL)",
  "Proform Shipper": "Proforma Shipper",
  "Proform Supplier (PS)": "Proforma Supplier (PS)",
  Proforma: "Proforma",
  "Shipping Instructions": "Shipping Instructions",
  Shippings: "Shippings",
  Totals: "Totals",

  // Auto-save translations
  unsavedChanges: "Unsaved Changes",
  unsavedChangesMessage:
    "You have pending modifications that have not been saved",
  newRecordNotSavedYet:
    "Este formulário ainda não foi salvo: aperte «Salvar» para criar o registro",
  savingIn: "Saving in",
  saving: "Saving",
  disableAutoSave: "Disable autosave",

  // Calendar translations
  calendar: {
    weekDays: {
      sunday: "Sun",
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat",
    },
    todayEvents: {},
  },

  // Events Analyzer translations
  eventsAnalyzer: {
    today: {
      title: "Today's Events",
      noEvents: "No events for today",
      criteria:
        "Events happening exactly today: loadings, payments, collections, ETAs, Gate Out, etc.",
    },
    thisWeek: {
      title: "This Week",
      noEvents: "No events this week",
      criteria:
        "Events in the next 7 days: all important dates that expire this week",
    },
    nextEvents: {
      title: "Next Events",
      noEvents: "No upcoming events",
      criteria:
        "Events in the next 30 days (excluding this week): medium-term planning",
    },
    urgent: {
      title: "Urgent Events",
      noEvents: "No urgent events",
      criteria:
        "Events requiring immediate action: upcoming ETAs (3 days), unpaid overdue payments, incomplete overdue ETAs/Gate Out (status ≠ 6)",
    },
    criteria: {
      title: "Classification Criteria",
      close: "Close",
    },
    pendingPayment: "Pagamento pendente",
    viewDetails: "View Details",
  },

  // Operations Summary translations
  operationsSummary: {
    title: "Resumo de Operações",
    noOperations: "Nenhuma operação importante nos próximos dias.",
    help: "Ajuda",
    close: "Fechar",
    helpText: {
      title: "Critérios de Classificação",
      sections: {
        mainDates: {
          title: "Datas Principais do Embarque",
          eta: "ETA (Estimated Time of Arrival): Data estimada de chegada da nave/avião ao porto de destino. Importante para coordenar despacho aduaneiro e retirada da mercadoria.",
          etd: "ETD (Estimated Time of Departure): Data estimada de saída do navio/avião do porto de origem. Marca o início do trânsito internacional.",
        },
        cutOffs: {
          title: "Cut Offs",
          documents:
            "Cut Off Documents: Deadline for presenting export documentation. If not met, the shipment may be left out of the voyage.",
          physical:
            "Cut Off Physical: Deadline for physically delivering cargo to the terminal. After this point, the container can no longer be accepted.",
        },
        cargoMovements: {
          title: "Cargo Movements",
          loading:
            "Loading Date: Day when cargo is loaded onto the vessel/aircraft. Coincides with stevedoring operations at port.",
          gateOut:
            "Gate Out: Date when the container leaves the depot for the port terminal. Marks the beginning of custody by the carrier.",
        },
        documentation: {
          title: "Commercial Documentation",
          dateReleased:
            "Date Released: Date when shipping documents are released. From here, the importer can manage pickup at destination.",
        },
        importPermits: {
          title: "Import Permits",
          expiration:
            "Import Permit Expiration: Expiration date of the permit. If it expires before cargo arrival, it cannot be nationalized.",
        },
        payments: {
          title: "Payment Dates",
          paymentDate:
            "Payment Date: Date when something needs to be paid. Critical for maintaining cash flow and avoiding penalties.",
        },
      },
    },
    messages: {
      eta: {
        today:
          "🚢 <strong>Arrival today!</strong> {count} {vessel} {verb} today at the destination port. Time to coordinate customs clearance and cargo pickup.",
        tomorrow:
          "🚢 <strong>Arrival tomorrow:</strong> {count} {vessel} {verb} tomorrow. Get ready for customs clearance.",
        thisWeek:
          "🚢 <strong>This week:</strong> {count} {vessel} {verb} this week. Coordinate with the importer for pickup.",
      },
      etd: {
        today:
          "⚓ <strong>Departure today:</strong> {count} {vessel} {verb} today from the origin port. International transit has begun.",
        tomorrow:
          "⚓ <strong>Departure tomorrow:</strong> {count} {vessel} {verb} tomorrow. Last chance to complete documentation.",
        thisWeek:
          "⚓ <strong>This week:</strong> {count} {vessel} {verb} this week from the origin port.",
      },
      loading: {
        today:
          "📦 <strong>Loading today:</strong> {count} {container} {verb} today on the vessel. Stevedoring operations at port.",
        tomorrow:
          "📦 <strong>Loading tomorrow:</strong> {count} {container} {verb} tomorrow.",
        thisWeek:
          "📦 <strong>This week:</strong> {count} {container} {verb} this week.",
      },
      gateOut: {
        today:
          "🚛 <strong>Gate Out today:</strong> {count} {container} {verb} today from the depot to the port terminal.",
        tomorrow:
          "🚛 <strong>Gate Out tomorrow:</strong> {count} {container} {verb} tomorrow to the port.",
        thisWeek:
          "🚛 <strong>This week:</strong> {count} {container} {verb} this week to the terminal.",
      },
      payment: {
        today:
          "💰 <strong>Payment today:</strong> {count} {payment} {verb} today. Attention! Check the status of pending payments.",
        tomorrow:
          "💰 <strong>Payment tomorrow:</strong> {count} {payment} {verb} tomorrow. Get ready to make payments.",
        thisWeek:
          "💰 <strong>This week:</strong> {count} {payment} {verb} this week.",
      },
      cutOffDocs: {
        today:
          "📄 <strong>Cut Off documents today:</strong> {count} {operation} {verb} document closure today. Last chance!",
        tomorrow:
          "📄 <strong>Cut Off documents tomorrow:</strong> {count} {operation} {verb} document closure tomorrow.",
        thisWeek:
          "📄 <strong>This week:</strong> {count} {operation} {verb} document closure this week.",
      },
      cutOffPhysical: {
        today:
          "📦 <strong>Cut Off physical today:</strong> {count} {operation} {verb} physical closure today. Last chance!",
        tomorrow:
          "📦 <strong>Cut Off physical tomorrow:</strong> {count} {operation} {verb} physical closure tomorrow.",
        thisWeek:
          "📦 <strong>This week:</strong> {count} {operation} {verb} physical closure this week.",
      },
      dateReleased: {
        today:
          "📋 <strong>Documents released today:</strong> {count} {document} {verb} today. The importer can manage pickup.",
        tomorrow:
          "📋 <strong>Documents tomorrow:</strong> {count} {document} {verb} tomorrow.",
        thisWeek:
          "📋 <strong>This week:</strong> {count} {document} {verb} this week.",
      },
      importPermit: {
        today:
          "🛂 <strong>Permits expire today:</strong> {count} {permit} {verb} today. Critical! Without permit cannot be nationalized.",
        tomorrow:
          "🛂 <strong>Permits tomorrow:</strong> {count} {permit} {verb} tomorrow. Renew urgently.",
        thisWeek:
          "🛂 <strong>This week:</strong> {count} {permit} {verb} this week.",
      },
    },
    words: {
      vessel: { single: "vessel", plural: "vessels" },
      container: { single: "container", plural: "containers" },
      payment: { single: "payment", plural: "payments" },
      operation: { single: "operation", plural: "operations" },
      document: { single: "document set", plural: "document sets" },
      permit: { single: "permit", plural: "permits" },
      arrives: { single: "arrives", plural: "arrive" },
      leaves: { single: "departs", plural: "depart" },
      loads: { single: "is loaded", plural: "are loaded" },
      goesOut: { single: "goes out", plural: "go out" },
      expires: { single: "expires", plural: "expire" },
      has: { single: "has", plural: "have" },
      releases: { single: "is released", plural: "are released" },
    },
  },

  // Calendar Tutorial translations
  calendarTutorial: {
    // Welcome step
    calendarWelcome: {
      title: "Welcome to Calendar Tutorial",
      description:
        "I will guide you through the ExportAI calendar functionality and explain the meaning of shipping status colors.",
      details: [
        "You will learn to navigate the monthly calendar",
        "You will understand how events and important dates are displayed",
        "You will know the meaning of each shipping status color",
        "You will know how to interact with calendar days and events",
      ],

      tip: "The calendar is your main tool for visualizing and managing all important dates of your trading operations.",
    },

    // Calendar navigation step
    calendarNavigation: {
      title: "Calendar Navigation",
      description:
        "Navigation buttons allow you to move between months to see events in different periods.",
      details: [
        "Left button: Go back to previous month",
        "Right button: Go forward to next month",
        "Current month and year are displayed in the center",
        "Navigation is instant and maintains your current view",
      ],

      tip: "Use navigation to plan future operations or review past events.",
    },

    // Calendar days step
    calendarDays: {
      title: "Calendar Days",
      description:
        "Each calendar day shows visual information about events and important dates.",
      details: [
        "Current month days are shown on white background",
        "Other months days are shown in gray",
        "Current day is highlighted with a blue border",
        "Days with events have a light blue background",
      ],

      tip: "Days with events are easy to identify by their light blue background.",
    },

    // Event display step
    eventDisplay: {
      title: "Event Display",
      description:
        "Events are shown within each calendar day with relevant information.",
      details: [
        "Each event shows the field and item name",
        "Shipping events show colors according to their status",
        "Proform events are shown in standard blue",
        "You can see multiple events on the same day",
      ],

      tip: "Event colors give you quick information about the state of your operations.",
    },

    // Shipping colors step
    shippingColors: {
      title: "Shipping Status Colors",
      description:
        "Shipping events are shown with specific colors that indicate their priority and state.",
      details: [
        "Gray: No priority (initial state)",
        "Yellow: Pending operation",
        "Orange: Delayed operation",
        "Blue: Departure date reached",
        "Red: Arrival approaching (20 days or less)",
        "Green: In port (final state)",
      ],

      tip: "Colors allow you to quickly identify which operations require immediate attention.",
    },

    // Color meaning step
    colorMeaning: {
      title: "Color Meaning",
      description:
        "Each color represents a specific state calculated automatically by the system.",
      details: [
        "The system automatically calculates status based on dates",
        "Colors change automatically according to operation progress",
        "Green (in port) is the desired final state",
        "Red indicates that arrival is approaching and requires attention",
      ],

      tip: "Keep an eye on red and orange events, as they require immediate action.",
    },

    // Day interaction step
    dayInteraction: {
      title: "Day Interaction",
      description:
        "You can click on any calendar day to see more details of the events.",
      details: [
        "Click on a day with events to see the complete list",
        "If there is only one event, you will go directly to its detail",
        "If there are multiple events, a modal opens with the list",
        "From the modal you can navigate to any event",
      ],

      tip: "Use clicks on days to quickly access detailed information about your operations.",
    },

    // Event details step
    eventDetails: {
      title: "Day Events Panel",
      description:
        "The right panel shows events of the selected day with navigation options.",
      details: [
        "Shows the selected date in readable format",
        "Lists all events of the day with their type and name",
        "Each event has a button to see its complete details",
        "Events are grouped by model (Proform, Shipping)",
      ],

      tip: "This panel gives you a quick view of everything that happens on a specific day.",
    },

    // Completion step
    calendarCompletion: {
      title: "Calendar Tutorial Completed!",
      description:
        "Now you perfectly understand how the calendar works and the shipping color system.",
      details: [
        "Navigation: You know how to move between months and days",
        "Events: You understand how events are displayed and organized",
        "Colors: You know the meaning of each status color",
        "Interaction: You know how to access detailed information",
      ],

      tip: "The calendar is now your main tool for managing and visualizing all your trading operations!",
    },
  },

  listTitleHidden: "Ocultos",
  "Export to Excel": "Exportar para Excel",
  "Hide empty date": "Ocultar sem data",
  "Actions": "Ações",
  "Debit": "Débito",
  "Credit": "Crédito",
  "Attached File": "Arquivo anexo",
  "No transactions found matching your search": "Não há movimentos que correspondam à busca",
  "Hide movements that have no date": "Ocultar os movimentos que não têm data",
  "No payments found": "Nenhum pagamento encontrado",
  "No collects found": "Nenhuma cobrança encontrada",
  listTabActive: "Ativos",
  listTabArchived: "Arquivados",
  listTabAll: "Tudo",
  hide: "Esconder",
  hideInThisView: "Ocultar nesta vista",
  showInThisView: "Mostrar nesta vista",
  HideSelected: "Esconder selecionados",
  ShowSelected: "Mostrar selecionados",

  treeEdit: {
    dragToMove: "Arrastar para mover",
    elementName: "Nome do elemento",
    editElement: "Editar elemento",
    deleteElement: "Eliminar este elemento",

    accountingCode: "Código contabilístico para lançamentos",
    itemColor: "Cor do elemento",
    itemColorHint:
      "A cor é usada como fundo da etiqueta quando este elemento aparece numa listagem. Sem cor, aparece em cinzento.",
    noColor: "Sem cor",
    listTranslationsSection: "Traduções por idioma (opcional)",
    listTranslationsHint:
      "Se preencher um idioma, os utilizadores verão esse texto com a interface nesse idioma. Deixe vazio para usar o nome predefinido acima.",
  },
};
